function fetchResearchProjectQuery (rootQueryType, id, pageSize, page, sortField, sortOrder, filter) {
  rootQueryType = ['organisationalUnit', 'person'].includes(rootQueryType) ? rootQueryType : null
  id = rootQueryType === 'organisationalUnit' ? Number(id) : `${id}`

  // if the rootQueryType does not match for organisational unit or person then return nulls
  if (!rootQueryType) {
    return null
  }

  let variables = {
    id: id || null,
    pageSize: Number(pageSize) || 20,
    page: Number(page) || 1
  }

  if (sortOrder) {
    variables['sortOrder'] = sortOrder
  }

  if (sortField) {
    variables['sortField'] = sortField
  }

  if (filter && filter.year && Number(filter.year)) {
    variables['filterYear'] = Number(filter.year)
  }

  if (filter && filter.freetext && filter.freetext.length > 0) {
    variables['filterFreetext'] = filter.freetext
  }

  if (filter && filter.funding && filter.funding.length > 0) {
    variables['filterFunding'] = filter.funding
  }

  if (filter && filter.sdg && filter.sdg.length !== '') {
    let value = filter.sdg
    if (value.startsWith('SDG')) {
      let id = parseInt(value.slice(3))
      variables['filterSdgIds'] = [id]
    } else {
      variables['filterSdgCategory'] = value
    }
  }

  if (filter && filter.person && filter.person.length > 0) {
    variables['filterPerson'] = filter.person
  }

  if (filter && filter.status && filter.status.length > 0) {
    variables['filterStatus'] = filter.status
  }

  return {
    operationName: 'fetchResearchProjectQuery',
    query: `
      query fetchResearchProjectQuery(
        $id: ID!,
        $pageSize:Int!,
        $page:Int!,
        $sortOrder:SortOrder,
        $sortField:ProjectSortKeys,
        $filterYear:Int,
        $filterFreetext:String,
        $filterFunding:String,
        $filterSdgCategory:SdgCategory,
        $filterSdgIds:[Int],
        $filterPerson:String,
        $filterStatus:String
      ) {
        ${rootQueryType}(id: $id) {
          forschungsprojekt:projects(
            pageSize: $pageSize, page: $page, sortOrder: $sortOrder, orderBy:$sortField,
            filter: {
              year: $filterYear
              freeText: $filterFreetext
              funding: $filterFunding
              person: $filterPerson
              sdgCategory: $filterSdgCategory
              sdgIds: $filterSdgIds
              status: $filterStatus
            }
          ) {
            meta {
              totalPages
              totalEntries
              pageNumber
              pageSize
            }
            entries {
              ... on Project {
                _id:id
                _entityName
                primaryPublicIdent
                sdg {
                  _id:id
                  _stringRep
                }
                html {
                  de
                  en
                }
                publications_count
              }
            }
          }
        }
      }
    `,
    variables
  }
}

export { fetchResearchProjectQuery }



// WEBPACK FOOTER //
// ./src/graphql/project.js